const prefix = 'pag_lee_customer_portal';

export const cookiesConstants = {
  AUTH_ACCESS_TOKEN: `${prefix}.access_token`,
  AUTH_REFRESH_TOKEN: `${prefix}.refresh_token`,
  SELECTED_COMPANY_ID: `${prefix}.selected_company_id`,
  RESALE_ID: `${prefix}.resale_id`,
  SELECTED_COMPANY_NAME: `${prefix}.selected_company_name`,
  USER_TIME_ZONE: `${prefix}.time_zone`,
};
